import React from 'react';
import '../Footer/Styles.css';

const Footer = () => {
  return (
    <>
        <div className='footerContainer'>
            <p className='footerName'>© 2026 Rico Vanhoutteghem. All rights reserved.</p>
            <p className='footerName'><a href='/termsandconditions' className='footerNameMore'>Terms & Conditions</a> | <a href='/files/privacyverklaring/Rico-Vanhoutteghem-Privacyverklaring.pdf' className='footerNameMore'>Privacy policy</a></p>
        </div>
    </>
  )
}

export default Footer;